import { render, staticRenderFns } from "./BaseNotificationItem.vue?vue&type=template&id=22f76892&"
import script from "./BaseNotificationItem.vue?vue&type=script&lang=js&"
export * from "./BaseNotificationItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AvatarImage: require('/opt/buildhome/repo/components/global/Avatar/AvatarImage.vue').default})
